var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Card, Divider, LILAC_400, Typography, WHITE } from '@airtel/air-design-system';
import { View } from 'react-native';
import { PackDetailsListItemWidget } from '../pack-details-list-item-widget';
import { getPackDetailsWidgetStyles } from './PackDetailsWidgetStyles';
export var PackDetailsWidgetComponent = props => {
  var _props$id = props.id,
    id = _props$id === void 0 ? '' : _props$id,
    _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    _props$title = props.title,
    title = _props$title === void 0 ? '' : _props$title,
    multiTextTitle = props.multiTextTitle,
    _props$subTitle = props.subTitle,
    subTitle = _props$subTitle === void 0 ? '' : _props$subTitle,
    _props$ctaText = props.ctaText,
    ctaText = _props$ctaText === void 0 ? '' : _props$ctaText,
    onCtaPress = props.onCtaPress,
    onUserAction = props.onUserAction,
    restProps = __rest(props, ["id", "data", "style", "title", "multiTextTitle", "subTitle", "ctaText", "onCtaPress", "onUserAction"]);
  var showTopContainer = title || subTitle || ctaText;
  var packDetailsWidgetStyles = getPackDetailsWidgetStyles(props);
  return _jsxs(Card, Object.assign({
    showShadow: false,
    style: [packDetailsWidgetStyles.container, style]
  }, restProps, {
    children: [!!showTopContainer && _jsxs(_Fragment, {
      children: [_jsxs(View, Object.assign({
        style: packDetailsWidgetStyles.topContainer
      }, {
        children: [!!title && _jsx(Typography, {
          text: title,
          type: "title-single-line-md"
        }), !!multiTextTitle && _jsx(Typography, Object.assign({
          type: "title-single-line-md"
        }, multiTextTitle)), !!subTitle && _jsx(Typography, {
          text: subTitle,
          type: "body-single-line-lg",
          style: packDetailsWidgetStyles.subTitle,
          numberOfLines: 1
        }), !!ctaText && _jsx(Button, {
          title: ctaText,
          buttonType: "tertiary",
          onPress: () => {
            onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
              id
            }, onCtaPress));
          },
          style: packDetailsWidgetStyles.cta
        })]
      })), (data === null || data === void 0 ? void 0 : data.length) > 0 && _jsx(Divider, {
        height: 2,
        color: LILAC_400,
        shadowColor: WHITE
      })]
    }), data === null || data === void 0 ? void 0 : data.map((item, index) => (_createElement(PackDetailsListItemWidget, Object.assign({}, item, {
      id: id,
      onUserAction: onUserAction,
      key: "pack_details_list_item_" + (item === null || item === void 0 ? void 0 : item.packTitle) + index,
      hideDivider: index === data.length - 1
    }))))]
  }));
};
PackDetailsWidgetComponent.genericRendererKey = 'AirPackDetailsWidget';